import { call, put, takeLatest } from 'redux-saga/effects';

import { ApiResponse } from '../../api/callApi.js';
import * as recommendationsApi from '../../api/recommendations.js';
import { ChangeRecommendationSettingsType } from '../../api/recommendations.js';
import { Action } from '../../types/action.js';
import { RecommendationsSettings } from '../../types/Recommendations.js';
import {
  changeRecommendationsSettingsActions,
  getRecommendationsSettingsActions,
} from '../action/api/RecommendationsApi.js';

function* getRecommendationsSettings(action: Action<number>): Generator<any> {
  const response = yield call(
    recommendationsApi.getRecommendationsSettings,
    action.payload!,
  );

  const { success, data } = response as ApiResponse<RecommendationsSettings>;

  if (success) {
    yield put(getRecommendationsSettingsActions.success(data));
  } else {
    yield put(getRecommendationsSettingsActions.failed(data));
  }
}

function* changeRecommendationsSettings(
  action: Action<ChangeRecommendationSettingsType>,
): Generator<any> {
  const response = yield call(
    recommendationsApi.changeRecommendationSettings,
    action.payload!,
  );

  const { success, data } = response as ApiResponse<RecommendationsSettings>;

  if (success) {
    yield put(changeRecommendationsSettingsActions.success(data));
  } else {
    yield put(changeRecommendationsSettingsActions.failed(data));
  }
}

export default function* recommendationsSaga() {
  yield takeLatest(
    getRecommendationsSettingsActions.type.REQUEST,
    getRecommendationsSettings,
  );
  yield takeLatest(
    changeRecommendationsSettingsActions.type.REQUEST,
    changeRecommendationsSettings,
  );
}
